import { LinkIcon, LocationIcon, SparkleIcon } from '@/assets/icons'
import { daysBetween, formatCalendarDate } from '@lib/datetime'
import React from 'react'
import {
	DateDisplayText,
	DateDisplayValue,
	DateRangeDisplay,
	DateSelectorContainer,
	DateSeparator,
	DaysCount,
	EditButton,
	ImportButton,
	MapButton,
	ShareButton,
} from './DateSelector.styles'
import { DateSelectorProps } from './types'

const DateSelector: React.FC<DateSelectorProps> = ({ initialStartDate, initialEndDate, onEditClick, onShareClick, onMapClick, onImportClick }) => {
	const formatDateDisplay = (date: string): string => {
		if (!date) return 'Not set'
		return formatCalendarDate(date, 'medium') || 'Not set'
	}

	const calculateDays = (): number => {
		if (!initialStartDate || !initialEndDate) return 0
		return daysBetween(initialStartDate, initialEndDate) + 1
	}

	const dayCount = calculateDays()

	return (
		<DateSelectorContainer>
			<DateRangeDisplay>
				{dayCount > 0 && (
					<DaysCount>
						{dayCount} {dayCount === 1 ? 'Day' : 'Days'}
					</DaysCount>
				)}

				<DateSeparator>-</DateSeparator>

				<DateDisplayText>
					<DateDisplayValue>{formatDateDisplay(initialStartDate)}</DateDisplayValue>
					<DateSeparator>to</DateSeparator>
					<DateDisplayValue>{formatDateDisplay(initialEndDate)}</DateDisplayValue>
				</DateDisplayText>

				<DateSeparator>-</DateSeparator>

				{onEditClick && (
					<EditButton onClick={onEditClick}>Edit Trip Dates</EditButton>
				)}

				{onEditClick && (onImportClick || onMapClick || onShareClick) && <DateSeparator>-</DateSeparator>}

				{onImportClick && (
					<ImportButton onClick={onImportClick}>
						<SparkleIcon width={14} height={14} />
						Import
					</ImportButton>
				)}

				{onImportClick && onMapClick && <DateSeparator>-</DateSeparator>}

				{onMapClick && (
					<MapButton onClick={onMapClick}>
						<LocationIcon width={14} height={14} fill="currentColor" />
						View Map
					</MapButton>
				)}

				{onMapClick && onShareClick && <DateSeparator>-</DateSeparator>}

				{onShareClick && (
					<ShareButton onClick={onShareClick}>
						<LinkIcon width={14} height={14} fill="currentColor" />
						Share Itinerary
					</ShareButton>
				)}
			</DateRangeDisplay>
		</DateSelectorContainer>
	)
}

export default DateSelector
